import { callBackendService, generateAccountToken } from "./generic"
import axios from "axios";

const baseURL = window.base_URL;  //'https://apidev.mobily.com.sa/api/register/v1/'
const apiBaseURL = window.base_api_url;  //'https://apidev.mobily.com.sa/api'
const CEM_KEY = window['CEM_KEY'];

let config = {
  api: {
    baseURL: baseURL,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "",
      "cem-key": CEM_KEY
    },
  },
};
export const api = axios.create({ ...config.api });

export async function consumerBasicInfo(requestBody) {
  let result = await callBackendService(baseURL + 'consumer/basic-info', requestBody, 'POST')
  return result
}

export async function businessCorporateInfo(requestBody) {
  let result = await callBackendService(baseURL + 'corporate/corporate-info', requestBody, 'POST')
  return result
}

export async function verifyOTPCorporate(requestBody) {
  let result = await callBackendService(baseURL + 'corporate/verify', requestBody, 'POST')
  return result
}

export async function verifyOTP(requestBody) {
  let result = await callBackendService(baseURL + 'consumer/line/verify', requestBody, 'POST')
  return result
}

export async function businessBasicInfo(requestBody) {
  let result = await callBackendService(baseURL + 'corporate/basic-info', requestBody, 'POST')
  return result
}

export async function verifyUsername(requestBody) {
  let result = await callBackendService(baseURL + 'verify/username', requestBody, 'POST')
  return result.status
}

export async function resendCode(requestBody) {
  let result = await callBackendService(baseURL + 'code/resend', requestBody, 'POST')
  return result
}

export async function addLine(requestBody) {
  let result = await callBackendService(baseURL + 'consumer/line/add', requestBody, 'POST')
  return result
}

export async function verifyClient(requestBody) {
  let result = await callBackendService(baseURL + 'verify/client', requestBody, 'POST');
  return result
}

export function getPasswordCreteria() {
  return new Promise((resolve, reject) => {
    fetch(`${apiBaseURL}/digital/v1/data/mappings?contextId=CTX_LOOKUPS&catalogKey=account_mgmt_rules_info`, {
      method: 'GET',
      headers: {
        "Content-type": "application/json",
        "cem-key": CEM_KEY
      }
    }).then(res => res.text())
      .then((result) => {
        resolve(result);
      }).catch(err => {
        reject(err)
      });
  })
}

export async function verifyEmail(userName) {
  let token = await generateAccountToken(userName);

  return new Promise((resolve, reject) => {
    fetch(`${apiBaseURL}/userprofile/v1/verify-email`, {
      method: 'GET',
      headers: {
        "Content-type": "application/json",
        "TransactionId": new Date().getTime(),
        "lang": window.lang,
        "cem-key": CEM_KEY,
        "Authorization": "Bearer " + token
      }
    }).then(res => res.json())
      .then(result => resolve(result))
      .catch(err => reject(err));
  })

}

export async function confirmEmail({ userName, hashCode, otp }) {
  let token = await generateAccountToken(userName);
  var requestBody = {
    hashcode: hashCode,
    otp
  }

  return new Promise((resolve, reject) => {
    fetch(`${apiBaseURL}/userprofile/v1/profile/confirmemail`, {
      method: 'PUT',
      body: JSON.stringify(requestBody),
      headers: {
        "Content-type": "application/json",
        "TransactionId": new Date().getTime(),
        "lang": window.lang,
        "cem-key": CEM_KEY,
        "Authorization": "Bearer " + token
      }
    }).then(res => res.json())
      .then(result => resolve(result))
      .catch(err => reject(err));
  });
}

export function validateCorporateAccount(transactionId, billingNumber) {
  const data = {
    "transactionId": transactionId,
    "billingNumber": billingNumber
  }

  return new Promise((resolve, reject) => {
    fetch(`${apiBaseURL}/register/v1/corporate/validateAccount`, {
      method: 'POST',
      headers: {
        "Content-type": "application/json",
        "cem-key": CEM_KEY,
        "Authorization": `Bearer ${window.clientToken}`
      },
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then((result) => {
        resolve(result);
      }).catch(err => {
        reject(err)
      });
  })
}